/* eslint-disable react/no-danger */
/* eslint-disable css-modules/no-unused-class */
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import sanitizeHtml from 'sanitize-html';
import withStyles from 'isomorphic-style-loader/withStyles';
import Lightbox from 'react-image-lightbox';
import lightboxStyles from 'react-image-lightbox/style.css';
import cx from 'classnames';
import s from './Product.scss';

import {
  triggerEcommerceEvent,
  addToCartEvent,
} from '../../helpers/googleTagManager';

import Page from '../../components/Page';
import Grid from '../../components/Grid';
import Label from '../../components/Label';

import NumericInput from '../../components/NumericInput';
import Clickable from '../../components/Clickable';
import Checkbox from '../../components/Checkbox';
import Link from '../../components/Link';
import Field from '../../components/FormField';
import Modal from '../../components/Modal';
import AddGreeting from '../../components/AddGreeting';
import Slider from '../../components/Slider';
import Carousel from '../../components/Carousel';
import Price from '../../components/Price';

import Icon from '../../components/Icon';
import Gallery from '../../components/Gallery';
import Headroom from '../../components/Headroom';
import AutoSuggest from '../../components/AutoSuggest';
import { getSalesChannelBasketId } from '../../helpers/userStorage';
import { addProduct, createBasket, getBasket } from '../../actions/basket';
import DeliveryOptions from '../../components/DeliveryOptions';
import DateTimeOptions from '../../components/DateTimeOptions';

import {
  ICONS,
  ACCOUNT_TYPE,
  BASKET_PATH,
  SHOP_PATH,
  DELIVERY_METHODS,
  DISCLAIMER_ACTION,
  PRODUCT_TYPE,
  MOCK_TEXT,
  SALES_CHANNELS,
  SALES_CHANNELS_GROUP,
} from '../../constants';
import withResponsiveWrapper from '../../decorators/withResponsiveWrapper';
import {
  setField,
  setGreeting,
  setWrapping,
  setCurrentProduct,
  setCurrencyFilter,
  setDeliveryMethod,
} from '../../actions/product';
import {
  normalizeAddress,
  flattenRecipientInformation,
  createMarkup,
  priceFormat,
  urlPrefix,
  isProductPorInPortal,
  isPhysicalProduct,
  isAlphabetic,
} from '../../helpers';
import greetingImage from '../../assets/images/greeting.png';
// import giftwrap from '../../assets/images/giftwrap.png';

import {
  formMessages as messages,
  productMessages,
  shopMessages,
} from '../../defineMessages';

import history from '../../history';
import recipientFields from './fields';
import Select from '../../components/Select/Select';
import ProductSkeleton from './ProductSkeleton';
import ApplicationContext from '../../components/ApplicationContext';

import { setSalesChannel } from '../../actions/config';

const plusIconProps = isMobile => ({
  label: null,
  basic: false,
  'aria-label': 'add greeting',
  className: s.plusIconButton,
  children: [
    <Icon
      key="plus-icon"
      name={ICONS.PLUS}
      size={isMobile ? 18 : 24}
      fill="#fff"
    />,
  ],
});

const successIconProps = isMobile => ({
  label: null,
  basic: false,
  'aria-label ': 'update greeting',
  className: s.successIconButton,
  children: [
    <Icon
      key="plus-icon"
      name={ICONS.SUCCESSS_SIMPLE}
      size={isMobile ? 18 : 24}
      fill="#fff"
    />,
  ],
});

class Product extends Component {
  constructor(props) {
    super(props);
    this.state = {
      greetingModalVisible: {
        mobile: false,
        desktop: false,
      },
      lightbox: {
        photoIndex: 0,
        isOpen: false,
      },
      disclaimerChecked: false,
      disclaimerModalVisible: false,
      wrappingModalVisible: false,
      removeWrappingModalOpen: false,
      savedDeliveryMethod: null,
      addToCartModalVisible: false,
      addedToCartModalVisible: false,
      currencyChanged: false,
      postcodeError: false,
    };
  }

  componentDidMount() {
    const {
      salesChannelId,
      salesChannelGroup,
      product: {
        data: { title },
      },
      locale,
      countryCode,
      currency,
      basket: { vouchers = [] } = {},
    } = this.props;
    // temp safety solution (hide POR products in portal) if the user somehow manage to access the product
    if (isProductPorInPortal(title, salesChannelGroup)) {
      history.push(
        `${urlPrefix(SHOP_PATH, { locale, countryCode, currency })}`,
      );
    }
    if (
      vouchers.length &&
      salesChannelId !== SALES_CHANNELS.REDEEM &&
      salesChannelGroup !== SALES_CHANNELS_GROUP.PORTAL
    ) {
      this.ensureCorrectBasketAndSalesChannel();
    }
    this.gtmProductDetailViewEvent();
    this.getAndSetRecipientInformation();
  }

  gtmProductDetailViewEvent = () => {
    const {
      product: {
        data: { id, title },
        formData: { productPurchasePrice },
      },
      currency,
    } = this.props;

    triggerEcommerceEvent({
      eventName: 'productDetailView',
      eventData: {
        currencyCode: currency,
        detail: {
          products: [
            {
              id,
              name: title,
              price: productPurchasePrice,
            },
          ],
        },
      },
    });
  };

  // Components
  getUsps = () => {
    const {
      product: {
        data: { usps },
      },
    } = this.props;

    return (
      <Grid
        container
        spacing={16}
        component="ul"
        alignItems="center"
        justify="center"
      >
        {usps &&
          usps.map(({ content, icon, ...rest }) =>
            content ? (
              <Grid key={icon} component="li" item sm={24 / usps.length}>
                <Label icon={{ name: ICONS[icon], size: 24, ...rest }}>
                  <span dangerouslySetInnerHTML={createMarkup(content)} />
                </Label>
              </Grid>
            ) : null,
          )}
      </Grid>
    );
  };

  getUspsMobile = () => {
    const {
      data: { usps },
    } = this.props.product;

    return (
      <Carousel
        arrows
        arrowsClass="basic"
        arrowsSize="small"
        rootClass={s.usps}
      >
        {usps.map(({ content, icon, ...rest }, i) => (
          <div key={i} className={s.carousel__label}>
            <Icon
              name={ICONS[icon]}
              size={24}
              className={s.carousel__icon}
              {...rest}
            />
            <p
              className={s.carousel__text}
              dangerouslySetInnerHTML={{ __html: sanitizeHtml(content) }}
            />
          </div>
        ))}
      </Carousel>
    );
  };

  getGallery = () => {
    const {
      isMobile,
      isTouchCapable,
      isSmallScreen,
      product: {
        data: { title, gallery },
      },
    } = this.props;

    if (!gallery || gallery.length === 0) {
      return null;
    }

    const { lightbox } = this.state;
    const mainImageSource = gallery[lightbox.photoIndex]?.source;
    const nexImageSource =
      gallery[(lightbox.photoIndex + 1) % gallery.length]?.source;
    const prevImageSource =
      lightbox.photoIndex > 0
        ? gallery[(lightbox.photoIndex + gallery.length - 1) % gallery.length]
            ?.thumbnail
        : gallery[gallery.length - 1]?.thumbnail;

    const onCloseLightbox = () => {
      this.setState({ lightbox: { ...lightbox, isOpen: false } });
    };

    const onOpenLightbox = index => {
      this.setState({ lightbox: { photoIndex: index, isOpen: true } });
    };

    const nextImage = () => {
      this.setState({
        lightbox: {
          ...lightbox,
          photoIndex: (lightbox.photoIndex + 1) % gallery.length,
        },
      });
    };

    const prevImage = () => {
      this.setState({
        lightbox: {
          ...lightbox,
          photoIndex:
            lightbox.photoIndex > 0
              ? (lightbox.photoIndex - 1) % gallery.length
              : gallery.length - 1,
        },
      });
    };

    let visibleSlides = 1;
    if (gallery && gallery.length > 1) {
      visibleSlides = isSmallScreen ? 2.5 : 1.5;
    }

    return (
      <>
        {lightbox.isOpen && gallery.length > 0 && (
          <Lightbox
            imagePadding={64}
            mainSrc={mainImageSource}
            nextSrc={nexImageSource}
            prevSrc={prevImageSource}
            onCloseRequest={() => onCloseLightbox()}
            onMovePrevRequest={() => prevImage()}
            onMoveNextRequest={() => nextImage()}
          />
        )}
        {isMobile ? (
          <Slider
            visibleSlides={visibleSlides}
            arrows={!isTouchCapable}
            hoverArrows={!isTouchCapable}
            responsive={false}
            className={s.slider}
            infinite
            darkBackground
          >
            {gallery &&
              gallery.length > 0 &&
              gallery.map(({ source, thumbnail }, index) => (
                <Clickable
                  onClick={() => onOpenLightbox(index)}
                  naked
                  key={thumbnail}
                >
                  <img
                    key={source}
                    src={source}
                    alt={title}
                    crossOrigin="anonymous"
                    style={{ maxHeight: '225px', objectFit: 'contain' }}
                  />
                </Clickable>
              ))}
          </Slider>
        ) : (
          <Gallery onOpen={onOpenLightbox}>
            {gallery &&
              gallery.length > 0 &&
              gallery.map(({ source }) => {
                return (
                  <img
                    key={source}
                    src={source}
                    alt={title}
                    crossOrigin="anonymous"
                  />
                );
              })}
          </Gallery>
        )}
      </>
    );
  };

  getRedeemMarkup = () => {
    let markupText;
    let returnData;
    const {
      product: {
        data: { productType },
      },
      salesChannelId,
      salesChannelGroup,
      page: {
        productRedeemInfoTitle,
        productRedeemInfoText,
        productRedeemInfoTextPhysProd,
      },
    } = this.props;
    const isCurrentProductPhysical = isPhysicalProduct(productType);
    if (
      salesChannelId === SALES_CHANNELS.REDEEM ||
      salesChannelGroup === SALES_CHANNELS_GROUP.PORTAL
    ) {
      if (productRedeemInfoText && !isCurrentProductPhysical) {
        markupText = productRedeemInfoText;
      } else if (isCurrentProductPhysical && productRedeemInfoTextPhysProd) {
        markupText = productRedeemInfoTextPhysProd;
      }
    }
    if (markupText) {
      returnData = (
        <section className={s.redeemInfo}>
          <Label tag="h2" bold className={cx(s.title)}>
            {productRedeemInfoTitle}
          </Label>
          <p dangerouslySetInnerHTML={createMarkup(markupText)} />
        </section>
      );
    }
    return returnData;
  };

  getRedeemMarkupForMobile = () => {
    let markupText;
    let returnData;
    const {
      product: {
        data: { productType },
      },
      salesChannelId,
      salesChannelGroup,
      page: {
        productRedeemInfoTextMobile,
        productRedeemInfoTextPhysProdMobile,
      },
    } = this.props;
    const isCurrentProductPhysical = isPhysicalProduct(productType);
    if (
      salesChannelId === SALES_CHANNELS.REDEEM ||
      salesChannelGroup === SALES_CHANNELS_GROUP.PORTAL
    ) {
      if (productRedeemInfoTextMobile && !isCurrentProductPhysical) {
        markupText = productRedeemInfoTextMobile;
      } else if (
        isCurrentProductPhysical &&
        productRedeemInfoTextPhysProdMobile
      ) {
        markupText = productRedeemInfoTextPhysProdMobile;
      }
    }
    if (markupText) {
      returnData = (
        <div
          style={{ width: '100%' }}
          dangerouslySetInnerHTML={createMarkup(markupText)}
        />
      );
    }
    return returnData;
  };

  getDeliveryOptions = () => {
    const {
      product: {
        data: { deliveryMethods, productType },
        formData,
      },
      intl: { formatMessage },
      mode,
    } = this.props;
    const {
      store: { dispatch },
    } = this.context;

    const options =
      deliveryMethods &&
      Object.keys(deliveryMethods).map(key => ({
        value: key,
        label: formatMessage({ ...messages[key] }),
        isSelected: formData.deliveryMethod === key,
        required: true,
        icon: ICONS[`DELIVERY_${key.toUpperCase()}`],
        onChange: (name, value) => {
          if (
            this.state.removeWrappingModalOpen === false &&
            formData?.addWrapping &&
            value !== DELIVERY_METHODS.PHYSICAL
          ) {
            this.setState({
              removeWrappingModalOpen: true,
              savedDeliveryMethod: value,
            });
          } else {
            dispatch(
              setCurrentProduct({
                value: '',
                sku: formData.stockKeepingUnit,
                defaultPriceCurrency: formData.valueCurrency,
                price: formData.productPurchasePrice,
              }),
            );
            dispatch(setDeliveryMethod({ deliveryMethod: value }));
          }
        },
      }));

    if (options) {
      const className = cx(
        s.section,
        Object.keys(deliveryMethods).length > 3 && s.hideIcons,
      );
      const notPhysicalProduct = productType !== PRODUCT_TYPE.physicalProduct;
      return (
        <Fragment>
          {notPhysicalProduct ? (
            <div className={className}>
              <DeliveryOptions
                options={options}
                label={formatMessage({ ...messages.delivery })}
              />
            </div>
          ) : null}
          {mode !== ACCOUNT_TYPE.REDEEM &&
            formData.deliveryMethod !== DELIVERY_METHODS.PHYSICAL && (
              <div className={s.section}>
                <DateTimeOptions
                  formId="product-form"
                  onChange={value => {
                    dispatch(setField('deliveryDate', value));
                  }}
                />
              </div>
            )}
        </Fragment>
      );
    }

    return null;
  };

  getFromPrice = () => {
    const {
      amounts,
      currency,
      intl: { formatMessage },
    } = this.props;
    if (!amounts) {
      return '';
    }
    const { defaultPriceCurrency, defaultPrice } =
      amounts.find(t => t.defaultPriceCurrency === currency) || {};
    return (
      <Price
        value={defaultPrice}
        currency={defaultPriceCurrency}
        prefix={formatMessage({ ...shopMessages.from })}
      />
    );
  };

  getAmountOptions = () => {
    const {
      currency,
      amounts,
      product: {
        formData,
        stockInfo,
        data: { productType },
      },
      intl: { formatMessage, formatNumber },
      mode,
      currencyFilter,
    } = this.props;

    const { currencyChanged } = this.state;

    const {
      store: { dispatch },
    } = this.context;
    if (typeof amounts === 'undefined') {
      return null;
    }

    let selectOptions = [];
    const currencies = new Set();
    let selectedOptionLabel;
    const emptyStockMessage = formatMessage({
      ...productMessages.amountNotInStock,
    });
    amounts.forEach(
      ({ sku, price, defaultPriceCurrency, defaultPrice, attributes }) => {
        let hint;
        let labelAttributes;

        const usedStock = stockInfo?.find?.(
          ({ deliveryMethod }) => deliveryMethod === formData?.deliveryMethod,
        );

        const { inStock } = usedStock?.skuStockInfo?.find(
          ({ sku: stockSku }) => stockSku === sku,
        ) || { inStock: false };

        if (!currencies.has(defaultPriceCurrency)) {
          currencies.add(defaultPriceCurrency);
        }
        if (currency !== defaultPriceCurrency) {
          hint = priceFormat({
            value: price,
            currency,
            formatNumber,
          });
        }
        if (attributes.length > 0) {
          labelAttributes = attributes.reduce(
            (sum, { name }) => (sum === '' ? name : `${sum}, ${name}`),
            '',
          );
        }

        const label = priceFormat({
          value: defaultPrice,
          currency: defaultPriceCurrency,
          defaultCurrency: currency,
          formatNumber,
          prefix: labelAttributes,
          parenthesis: labelAttributes !== undefined,
          showCurrency: true,
        });

        const isSelected =
          formData.giftcardValue === defaultPrice &&
          formData.stockKeepingUnit === sku &&
          formData.valueCurrency === defaultPriceCurrency;

        if (isSelected) {
          selectedOptionLabel = labelAttributes;
        }

        const option = {
          value: defaultPrice,
          currency: defaultPriceCurrency,
          inStock,
          emptyStockMessage,
          label,
          hint,
          isSelected,
          required: true,
          onChange: value => {
            // For products with a price range (ie supergiftcard), sku will always be the same
            // for the range per currency.
            // but "ordinary" products will have a different sku for each price
            // Prices can also be set with different currencies for both ranged and ordinary
            if (inStock) {
              dispatch(
                setCurrentProduct({
                  value,
                  sku,
                  defaultPriceCurrency,
                  // Needed to determine if redeem or purchase labels should be shown
                  price,
                }),
              );
            }
          },
        };

        selectOptions.push(option);
      },
    );

    // Only show the default display currency when there are more than one currency
    // available for a product when B2C
    // Show a filter of available currencies when B2B

    let amountXs = 24;

    if (currencies.size > 1) {
      if (mode === ACCOUNT_TYPE.B2B) {
        if (currencyFilter) {
          if (formData.valueCurrency !== currency && !currencyChanged) {
            dispatch(setCurrencyFilter({ currency }));
          }
          selectOptions = selectOptions.filter(
            option => option.currency === currencyFilter,
          );
        } else if (currency) {
          if (formData.valueCurrency !== currency) {
            dispatch(setCurrencyFilter({ currency }));
          }
          selectOptions = selectOptions.filter(
            option => option.currency === currency,
          );
        }
        amountXs = 16;
      } else if (currencies.has(currency)) {
        // This is ugly but I'm too tired to do this in GET_SINGLE_PRODUCT
        if (formData.valueCurrency !== currency) {
          dispatch(setCurrencyFilter({ currency }));
        }
        selectOptions = selectOptions.filter(
          option => option.currency === currency,
        );
      }
    }

    const currencyOptions = Array.from(currencies).map(c => ({
      label: c,
      value: c,
    }));

    const valueLabel = formData.giftcardValue
      ? priceFormat({
          value: formData.giftcardValue,
          currency: formData.valueCurrency,
          defaultCurrency: currency,
          formatNumber,
          prefix: selectedOptionLabel || false,
          parenthesis: !!selectedOptionLabel,
          showCurrency: true,
        })
      : null;
    const retailPrice = amounts?.reduce((prev, amount) => {
      if (amount.defaultPriceCurrency === currency) {
        return amount;
      }
      return prev;
    }, {});
    const iscurrentProductPhysical = isPhysicalProduct(productType);
    return (
      <Fragment>
        <div className={s.section}>
          <Grid
            container
            direction={iscurrentProductPhysical ? 'column' : 'row'}
            spacing={16}
            wrap="wrap"
          >
            {selectOptions.length > 0 && (
              <>
                {iscurrentProductPhysical ? (
                  <>
                    <hr className={s['divider-line']} />
                    <Grid item xs={amountXs}>
                      <Label tag="h3" bold>
                        {formatMessage({ ...shopMessages.yourPrice })}{' '}
                        <Price
                          value={retailPrice?.price}
                          currency={retailPrice.defaultPriceCurrency}
                        />
                      </Label>
                    </Grid>
                    <hr className={s['divider-line']} />
                  </>
                ) : (
                  <>
                    <Grid item xs={amountXs}>
                      <Field
                        basic
                        fluid
                        input={AutoSuggest}
                        value={formData.giftcardValue}
                        valueLabel={valueLabel}
                        name="giftcardValue"
                        options={selectOptions}
                        showLabel
                        required
                        label={formatMessage({ ...messages.amount })}
                        onChange={value =>
                          value && this.setState({ giftcardValue: null })
                        }
                        hasError={
                          this.state && this.state.giftcardValue
                            ? { message: this.state.giftcardValue.message }
                            : false
                        }
                        placeHolder={formatMessage({
                          ...productMessages.chooseValue,
                        })}
                      />
                    </Grid>
                    {amountXs === 16 && (
                      <Grid item xs={24 - amountXs}>
                        <Field
                          basic
                          fluid
                          input={Select}
                          className={s['form-label']}
                          value={currencyFilter || currency}
                          name="giftcardValue"
                          label={formatMessage({ ...messages.currency })}
                          labelRootClass={cx(s.title, s['form-label'])}
                          options={currencyOptions}
                          onChange={({ target: { value } }) => {
                            this.setState({ currencyChanged: true });
                            dispatch(setCurrencyFilter({ currency: value }));
                          }}
                        />
                      </Grid>
                    )}
                  </>
                )}
              </>
            )}
          </Grid>
        </div>
        <div className={s.section}>
          <Field
            input={NumericInput}
            name="quantity"
            aria-label="quantity"
            type="number"
            fluid
            required
            label={formatMessage({ ...messages.quantity })}
            format={number => `${number}`}
            value={formData.quantity}
            onChange={({ target: { value } }) =>
              dispatch(setField('quantity', value))
            }
          />
        </div>
      </Fragment>
    );
  };

  getAndSetRecipientInformation = () => {
    const {
      product: {
        formData,
        data: { productType },
      },
      basket: { data },
    } = this.props;
    const {
      store: { dispatch },
    } = this.context;

    const recipientInformation = flattenRecipientInformation(data);

    if (!recipientInformation) return false;

    const parsedRecipientInformation = {
      ...recipientInformation,
      ...recipientInformation.recipientAddress,
    };

    Object.keys(recipientFields[productType]).forEach(key => {
      recipientFields[productType][key].forEach(({ name }) => {
        if (
          !formData[name] &&
          parsedRecipientInformation[name] &&
          parsedRecipientInformation[name] !== MOCK_TEXT
        ) {
          dispatch(setField(name, parsedRecipientInformation[name]));
        }
      });
    });

    ['Email', 'Phone'].forEach(key => {
      if (
        !formData[`recipient${key}`] &&
        recipientInformation[`recipient${key}`]
      ) {
        dispatch(
          setField(
            `recipient${key}Repeat`,
            recipientInformation[`recipient${key}`],
          ),
        );
      }
    });

    return false;
  };

  getRecipientFields = () => {
    const {
      product: {
        formData,
        data: { productType },
      },
      intl: { formatMessage },
    } = this.props;
    const {
      store: { dispatch },
    } = this.context;

    if (typeof formData.deliveryMethod === 'undefined' || !productType) {
      return null;
    }

    return (
      <Grid container spacing={16}>
        {isPhysicalProduct(productType) && (
          <Grid item xs={24}>
            <Label className={s.info}>
              {formatMessage({ ...messages.physicalProductHelp })}
            </Label>
          </Grid>
        )}
        {recipientFields[productType][formData.deliveryMethod].map(
          ({
            label,
            name,
            placeholder,
            type,
            component,
            required,
            responsive,
            ...rest
          }) => (
            <Grid key={name} item {...responsive}>
              <Field
                input={component}
                type={type}
                name={name}
                label={formatMessage({ ...messages[label] })}
                showLabel
                placeholder={
                  placeholder && formatMessage({ ...messages[placeholder] })
                }
                required={required}
                value={formData[name]}
                onChange={value => dispatch(setField(name, value))}
                validationCallback={isValid => this.setValidationError(isValid)}
                onFocus={() => this.setState({ [name]: undefined })}
                hasError={
                  this.state && this.state[name]
                    ? { message: this.state[name].message }
                    : !!(name === 'postCode' && this.state.postcodeError)
                }
                {...rest}
              />
            </Grid>
          ),
        )}
      </Grid>
    );
  };

  setValidationError = isValid => {
    this.validationError = isValid;
  };

  getGreetingModal = key => {
    const {
      product: {
        formData: { addGreeting },
      },
      isMobile,
    } = this.props;

    const { greetingModalVisible } = this.state;

    return (
      <Modal
        isVisible={greetingModalVisible[key]}
        handleClick={() => this.toggleGreetingModal(key)}
        fullScreen
        triggerProps={
          this.hasGreeting()
            ? successIconProps(isMobile)
            : plusIconProps(isMobile)
        }
      >
        <AddGreeting
          onCancel={() => this.toggleGreetingModal(key)}
          onAdd={greeting => this.addGreetingToProduct(greeting, key)}
          greeting={addGreeting || {}}
        />
      </Modal>
    );
  };

  getAddedToCartModal = () => {
    const {
      intl: { formatMessage },
    } = this.props;

    const { addedToCartModalVisible } = this.state;

    return (
      <Modal
        animation="fadeIn"
        maxWidth
        header={false}
        size="center"
        className={s.addedToCartModal}
        isVisible={addedToCartModalVisible}
        handleClick={() => this.toggleAddedToCartModal()}
      >
        <div className={s.addedToCartModal__content}>
          <Label tag="h3" bold className={cx(s.title, s['form-label'])}>
            {formatMessage({ ...productMessages.addedToCartModalTitle })}
          </Label>
          <p>{formatMessage({ ...productMessages.addedToCartModalText })}</p>
          <Grid container justify="space-around" spacing={16} wrap="wrap">
            <Grid item xs={24} md={12}>
              <Clickable primary fluid link={<Link to={BASKET_PATH} />}>
                {formatMessage({ ...productMessages.goToBasket })}
              </Clickable>
            </Grid>
            <Grid item xs={24} md={12}>
              <Clickable
                basic
                fluid
                onClick={() => this.toggleAddedToCartModal()}
                label={formatMessage({
                  ...productMessages.continueShopping,
                })}
                link={<Link to={SHOP_PATH} />}
              />
            </Grid>
          </Grid>
        </div>
      </Modal>
    );
  };

  checkDisclaimer = () => {
    const {
      intl: { formatMessage },
      addDisabled,
      product: {
        formData: { deliveryMethod },
        stockInfo,
        data: { disclaimer },
      },
      useRedeemLabels,
    } = this.props;
    const { disclaimerModalVisible, disclaimerChecked } = this.state;

    const { allSkusOutOfStock } = stockInfo?.find?.(
      ({ deliveryMethod: stockDeliveryMethod }) =>
        stockDeliveryMethod === deliveryMethod,
    ) || { allSkusOutOfStock: true };

    const labelAddToCartId = useRedeemLabels ? 'addToCartRedeem' : 'addToCart';

    const labelAddToCart = formatMessage({
      ...productMessages[labelAddToCartId],
    });

    const disclaimerBody = disclaimer?.body || '';

    const disclaimerTitle = disclaimer?.title || '';

    const disclaimerHasText = !!disclaimerTitle && !!disclaimerBody;

    if (disclaimer?.basketUserAction === DISCLAIMER_ACTION.checkbox) {
      return (
        <>
          <div className={s.section}>
            <Label tag="h3" bold className={cx(s.title, s['form-label'])}>
              {disclaimerTitle}
            </Label>
            <div
              dangerouslySetInnerHTML={{
                __html: sanitizeHtml(disclaimerBody),
              }}
            />
            <div className={s.padding}>
              <Checkbox
                showLabel
                checked={disclaimerChecked}
                onChange={() => {
                  this.setState({
                    disclaimerChecked: !disclaimerChecked,
                  });
                }}
                label={
                  <Label tag="p" bold>
                    {formatMessage({ ...productMessages.disclaimerAgree })}
                  </Label>
                }
              />
            </div>
          </div>
          <div className={s.submit}>
            <Clickable
              id="addToCart"
              type="submit"
              disabled={addDisabled || allSkusOutOfStock || !disclaimerChecked}
              primary
              label={labelAddToCart}
            />
          </div>
        </>
      );
    }
    if (
      disclaimer?.basketUserAction === DISCLAIMER_ACTION.button &&
      disclaimerHasText
    ) {
      return (
        <Modal
          animation="fadeIn"
          header={false}
          maxWidth
          size="center"
          className={s.disclaimerModal}
          isVisible={disclaimerModalVisible}
          headerClassName={s.disclaimerModalHeader}
          triggerProps={{
            fluid: true,
            disabled: allSkusOutOfStock,
            id: 'addToCart',
            type: 'submit',
            primary: true,
            label: labelAddToCart,
            className: s.submit,
          }}
        >
          <div className={s.addedToCartModal__content}>
            <Label tag="h3" bold className={cx(s.title, s['form-label'])}>
              {disclaimerTitle}
            </Label>
            <div
              dangerouslySetInnerHTML={{
                __html: sanitizeHtml(disclaimerBody),
              }}
            />
            <Grid container justify="space-around" spacing={16} wrap="wrap">
              <Grid item xs={24} md={12}>
                <Clickable
                  basic
                  fluid
                  onClick={this.toggleDisclaimerModal}
                  label={formatMessage({ ...productMessages.cancel })}
                />
              </Grid>
              <Grid item xs={24} md={12}>
                <Clickable
                  primary
                  fluid
                  onClick={e => {
                    this.toggleDisclaimerModal(e);
                    this.addProduct(e);
                  }}
                  label={formatMessage({ ...productMessages.disclaimerAgree })}
                />
              </Grid>
            </Grid>
          </div>
        </Modal>
      );
    }
    return (
      <>
        {disclaimerTitle && (
          <div className={cx(s.section)}>
            <Label tag="h3" bold className={cx(s.title, s['form-label'])}>
              {disclaimerTitle}
            </Label>
            <div
              dangerouslySetInnerHTML={{
                __html: sanitizeHtml(disclaimerBody),
              }}
            />
          </div>
        )}
        <div className={s.submit}>
          <Clickable
            id="addToCart"
            type="submit"
            disabled={addDisabled || allSkusOutOfStock}
            primary
            label={labelAddToCart}
          />
        </div>
      </>
    );
  };

  getAddToCart = () => {
    const {
      intl: { formatMessage },
      product: {
        data: { disclaimer, productType },
      },
      salesChannelId,
      salesChannelGroup,
      mode,
    } = this.props;
    const disclaimerHasText = !!disclaimer?.title && !!disclaimer?.body;

    return (
      <form
        id="product-form"
        onSubmit={event => {
          event.preventDefault();
          if (!this.validation(event.target.elements)) {
            return;
          }
          if (
            disclaimer?.basketUserAction === DISCLAIMER_ACTION.button &&
            disclaimerHasText
          ) {
            this.toggleDisclaimerModal(event);
            return;
          }
          this.addProduct(event);
        }}
        noValidate
      >
        {/* <!-- Visually hidden section heading for screen readers --> */}
        <h2 id="product-form-heading" className="visually-hidden">
          Product form
        </h2>
        {this.getRedeemMarkup()}
        {this.getDeliveryOptions()}
        {this.getAmountOptions()}
        {!(
          salesChannelId === SALES_CHANNELS.REDEEM ||
          salesChannelGroup === SALES_CHANNELS_GROUP.PORTAL
        ) && (
          <div className={cx(s.section)}>
            <Label tag="h3" bold className={cx(s.title, s['form-label'])}>
              {formatMessage({ ...messages.recipient })}
            </Label>
            <p>
              {formatMessage({
                ...messages.recipientDescription,
              })}
            </p>
            <div
              role="group"
              aria-labelledby="Recipient"
              className={s.fieldset}
            >
              {this.getRecipientFields()}
            </div>
          </div>
        )}
        {mode !== ACCOUNT_TYPE.REDEEM &&
          productType !== PRODUCT_TYPE.physicalProduct && (
            <div className={cx(s.section)}>
              <Label tag="h3" bold className={cx(s.title, s['form-label'])}>
                {formatMessage({ ...messages.extras })}
              </Label>
              <div className={cx(s.panel, s.padding__full)}>
                <Grid container spacing={8} alignItems="center">
                  <Grid item xs={4} md={6}>
                    <img
                      className={s.image}
                      src={greetingImage}
                      alt="Create Greeting"
                    />
                  </Grid>
                  <Grid item xs={16} md={12}>
                    <Label className={s.title} bold tag="h3">
                      {formatMessage({
                        ...productMessages.greetingCard,
                      })}
                    </Label>
                    <Label tag="p">
                      {formatMessage({
                        ...productMessages.greetingCardDescription,
                      })}
                    </Label>
                  </Grid>
                  <Grid
                    container
                    xs={4}
                    md={6}
                    alignItems="center"
                    justify="flex-end"
                  >
                    {this.getGreetingModal('desktop')}
                  </Grid>
                </Grid>
              </div>
            </div>
          )}
        {this.checkDisclaimer()}
        {this.getAddedToCartModal()}
      </form>
    );
  };

  getAddToCartDialogHeader = () => {
    const {
      product: {
        data: { title, logoSquare },
      },
      intl: { formatMessage },
    } = this.props;
    return (
      <div className={s.modalHeader}>
        <Grid container spacing={8}>
          <Grid item xs={6} className={s.informationGrid}>
            <img
              src={logoSquare}
              alt={formatMessage(productMessages.altProductLogo, {
                title,
              })}
            />
          </Grid>
          <Grid item xs={16} className={s.informationGrid}>
            <Label bold className={s.title__footer} label={title} tag="h2" />
          </Grid>
        </Grid>
      </div>
    );
  };

  getMobileFooter = addToCartButton => {
    const {
      amounts,
      product: {
        data: { title, logoSquare, productType, excerpt },
        productNotInStock,
      },
      intl: { formatMessage },
      useRedeemLabels,
      mode,
      currency,
    } = this.props;

    const { addToCartModalVisible } = this.state;

    const labelAddToCartId = useRedeemLabels ? 'addToCartRedeem' : 'addToCart';
    const label = formatMessage({
      ...productMessages[labelAddToCartId],
    });

    const iconProps = {
      basic: false,
      className: cx(
        s.buyButton,
        label.length === 4 && s.smallText,
        label.length === 5 && s.smallerText,
        label.length === 6 && s.miniText,
        label.length > 6 && s.minimalText,
      ),
      children: <Label>{label}</Label>,
    };
    const retailPrice = amounts?.reduce((prev, amount) => {
      if (amount.defaultPriceCurrency === currency) {
        return amount;
      }
      return prev;
    }, {});

    return (
      <div
        className={cx(
          s.mobileFooter,
          mode === ACCOUNT_TYPE.REDEEM && s.mobileFooter__redeem,
        )}
      >
        <Grid container spacing={8} style={{ marginBottom: '1rem' }}>
          <Grid container spacing={8} className={s.mobileProductPadding}>
            <Grid item xs={4}>
              <img
                src={logoSquare}
                alt={formatMessage(productMessages.altProductLogo, {
                  title,
                })}
                className={cx(s['logo-footer'])}
              />
            </Grid>
            <Grid
              item
              xs={20}
              className={cx(s.relative, s.mobileFooterProductInfo)}
            >
              <Label bold className={s.title__footer} label={title} tag="h2" />
              {!productNotInStock ? (
                <>
                  {isPhysicalProduct(productType) ? (
                    <Label tag="p" bold>
                      {formatMessage({ ...shopMessages.yourPrice })}{' '}
                      <Price
                        value={retailPrice?.price}
                        currency={retailPrice.defaultPriceCurrency}
                      />
                    </Label>
                  ) : (
                    <>
                      <p className={s.excerpt__footer}>{excerpt}</p>
                      <span className={s.mobilePriceFrom}>
                        {this.getFromPrice()}
                      </span>
                    </>
                  )}
                </>
              ) : (
                <Label className={cx(s.title, s.title__stock)} bold tag="h2">
                  {formatMessage({
                    ...productMessages.productNotInStock,
                  })}
                </Label>
              )}
            </Grid>
          </Grid>
          {!productNotInStock && (
            <Grid item xs={24} className={s.relative}>
              {addToCartButton && (
                <Modal
                  maxWidth
                  fullScreen
                  animation="slideUp"
                  triggerProps={iconProps}
                  headerAction={this.getAddToCartDialogHeader()}
                  isVisible={addToCartModalVisible}
                  handleClick={() => this.toggleAddToCartModal()}
                  headerClassName={s.addToCartModalHeader}
                >
                  <Grid container spacing={16}>
                    <Grid item xs={24} lg={12}>
                      <div className={s.padding}>{this.getAddToCart()}</div>
                    </Grid>
                  </Grid>
                </Modal>
              )}
            </Grid>
          )}
        </Grid>
      </div>
    );
  };

  // Handlers

  toggleDisclaimerModal = () => {
    const { disclaimerModalVisible } = this.state;

    this.setState({
      disclaimerModalVisible: !disclaimerModalVisible,
    });
  };

  toggleAddToCartModal = evt => {
    if (evt) evt.preventDefault();
    const { addToCartModalVisible } = this.state;

    this.setState({
      addToCartModalVisible: !addToCartModalVisible,
    });
  };

  toggleAddedToCartModal = evt => {
    if (evt) evt.preventDefault();
    const { addedToCartModalVisible } = this.state;

    this.setState({
      addedToCartModalVisible: !addedToCartModalVisible,
    });
  };

  toggleGreetingModal = key => {
    const { greetingModalVisible } = this.state;
    this.setState({
      greetingModalVisible: {
        ...greetingModalVisible,
        [key]: !greetingModalVisible[key],
      },
    });
  };

  toggleWrappingModal = evt => {
    if (evt) evt.preventDefault();
    const { wrappingModalVisible } = this.state;

    this.setState({ wrappingModalVisible: !wrappingModalVisible });
  };

  validation = elements => {
    let isValid = true;

    if (this.validationError) {
      return false;
    }
    const {
      product: { formData },
    } = this.props;

    // validate required fields
    for (let i = 0; i < elements.length; i += 1) {
      if (elements[i].hasAttribute('required') && elements[i].value === '') {
        this.setState({
          [elements[i].name]: {
            message: this.props.intl.formatMessage({ ...messages.required }),
          },
        });
        isValid = false;
      }
    }

    // validate name field
    if (formData.recipientName && !isAlphabetic(formData.recipientName)) {
      this.setState({
        recipientName: {
          message: this.props.intl.formatMessage({ ...messages.invalidName }),
        },
      });
      return false;
    }

    if (formData.deliveryMethod !== DELIVERY_METHODS.PHYSICAL) {
      // validate email/phone repeat fields
      if (!this.validateRepeat('Email')) return false;
      if (formData.deliveryMethod === DELIVERY_METHODS.SMS) {
        if (!this.validateRepeat('Phone')) return false;
      }
    }

    return isValid;
  };

  validateRepeat = name => {
    const {
      product: { formData },
      intl: { formatMessage },
    } = this.props;

    if (!formData[`recipient${name}`]) return true;

    if (formData[`recipient${name}`] !== formData[`recipient${name}Repeat`]) {
      this.setState({
        [`recipient${name}Repeat`]: {
          message: formatMessage({ ...messages[`${name}NotMatching`] }),
        },
      });

      return false;
    }

    return true;
  };

  addGiftWrappingToProduct = wrapping => {
    const { dispatch } = this.context.store;
    dispatch(setWrapping(wrapping));
    this.toggleWrappingModal();
  };

  addGreetingToProduct = (greeting, key) => {
    const { dispatch } = this.context.store;
    dispatch(setGreeting(greeting));
    this.toggleGreetingModal(key);
  };

  addProduct = async event => {
    event.preventDefault();
    const {
      basketId,
      product: {
        formData,
        data: { productType, title },
      },
      salesChannelId,
    } = this.props;

    const { dispatch } = this.context.store;

    // Just for physical products - address data will be set when choosing pickup point
    const defaultAddressData = {
      line1: MOCK_TEXT,
      city: MOCK_TEXT,
    };

    if (
      (formData.deliveryMethod !== DELIVERY_METHODS.PHYSICAL &&
        formData.AddWrapping) ||
      formData.addWrapping?.id === undefined
    ) {
      delete formData.AddWrapping;
    }

    const dataToNormalize = isPhysicalProduct(productType)
      ? {
          ...formData,
          ...defaultAddressData,
        }
      : {
          ...formData,
        };
    const normalizedData = normalizeAddress(dataToNormalize);
    if (!basketId) {
      await dispatch(createBasket(salesChannelId));
    }
    const addProductResponse = await dispatch(addProduct(normalizedData));
    if (!addProductResponse) {
      this.setState({
        postcodeError: true,
      });

      return false;
    }
    this.setState({ addedToCartModalVisible: true });

    this.gtmAddToCartEvent({ title, ...normalizedData, ...formData });

    return true;
  };

  gtmAddToCartEvent = ({
    title,
    productId,
    quantity,
    valueCurrency,
    productPurchasePrice,
  }) => {
    addToCartEvent({
      eventData: {
        currencyCode: valueCurrency,
        add: {
          products: [
            {
              id: productId,
              name: title,
              price: productPurchasePrice,
              quantity,
            },
          ],
        },
      },
    });
  };

  hasGreeting = () => {
    const { addGreeting } = this.props.product.formData;
    return (
      addGreeting &&
      (addGreeting.base64Image || addGreeting.text || addGreeting.videoId)
    );
  };

  async ensureCorrectBasketAndSalesChannel() {
    const {
      store: { dispatch },
    } = this.context;

    const { countryCode } = this.props;
    await dispatch(setSalesChannel(SALES_CHANNELS.REDEEM));
    // check userStorage for available baskets
    const { basketId: existingBasketId } =
      getSalesChannelBasketId({
        salesChannelId: SALES_CHANNELS.REDEEM,
        countryCode,
      }) || {};
    if (existingBasketId) {
      await dispatch(getBasket(existingBasketId));
    } else {
      await dispatch(createBasket(SALES_CHANNELS.REDEEM));
    }
  }

  static contextType = ApplicationContext;

  render() {
    const {
      product: {
        data: { title, excerpt, logoSquare, description, usps: productUsps },
        loading,
        productNotInStock,
      },
      intl: { formatMessage },
      isMobile,
    } = this.props;

    const usps = productUsps.filter(({ content }) => !!content);

    const options = {
      offset: 160,
      classes: {
        pinned: s.headroomPinned,
        unpinned: s.headroomUnpinned,
        top: s.headroomTop,
        notTop: s.headroomNotTop,
        initial: s.root,
      },
    };

    return (
      <Fragment>
        <Page className={s.root}>
          {loading ? (
            <ProductSkeleton />
          ) : (
            <Grid container spacing={16} className={s.main}>
              <Grid item xs={24} sm={24} md={5}>
                <Headroom options={options}>
                  <div
                    className={cx(s.panel, s.gallery)}
                    style={isMobile ? { marginBottom: 0 } : undefined}
                  >
                    {this.getGallery()}
                  </div>
                </Headroom>
              </Grid>
              {isMobile ? this.getRedeemMarkupForMobile() : null}
              <Grid item xs={24} sm={24} md={11}>
                <div className={cx(s.panel, s.padding, s.noPaddingMobile)}>
                  <Grid
                    container
                    spacing={16}
                    className={cx(
                      s.summary,
                      s.mobilePanel,
                      isMobile && s.space,
                    )}
                  >
                    <Grid item md={4} className="hidden-xs">
                      <img
                        className={cx(s['logo-sm'], 'hidden-sm')}
                        src={logoSquare}
                        alt={formatMessage(productMessages.altProductLogo, {
                          title,
                        })}
                      />
                    </Grid>
                    <Grid
                      item
                      sm={24}
                      md={20}
                      className={cx('sm-align-center')}
                    >
                      <Label bold className={s.title} label={title} tag="h1" />
                      <p className={s.excerpt}>{excerpt}</p>
                    </Grid>
                    {usps.length !== 0 && isMobile && (
                      <div className={cx(s.carousel)}>
                        {this.getUspsMobile()}
                      </div>
                    )}
                  </Grid>
                  {!isMobile && (
                    <div className={cx(s.padding, s.usps)}>
                      {this.getUsps()}
                    </div>
                  )}
                  {description && (
                    <div
                      className={cx(
                        s.padding,
                        s.mobilePanel,
                        s.productDescription,
                      )}
                    >
                      <div
                        dangerouslySetInnerHTML={createMarkup(description)}
                      />
                    </div>
                  )}
                </div>
              </Grid>
              {!isMobile && (
                <Grid item md={8}>
                  <Headroom options={options}>
                    <div className={cx(s.panel, s.padding, s.widthFix)}>
                      {!productNotInStock ? (
                        this.getAddToCart()
                      ) : (
                        <div className={s.padding}>
                          <Label
                            className={cx(s.title, s.title__stock)}
                            bold
                            tag="h2"
                          >
                            {formatMessage({
                              ...productMessages.productNotInStock,
                            })}
                          </Label>
                        </div>
                      )}
                    </div>
                  </Headroom>
                </Grid>
              )}
            </Grid>
          )}
        </Page>
        {!loading && isMobile && this.getMobileFooter(true)}
      </Fragment>
    );
  }
}

Product.propTypes = {
  product: PropTypes.shape().isRequired,
  intl: PropTypes.shape().isRequired,
  locale: PropTypes.string.isRequired,
  addDisabled: PropTypes.bool.isRequired,
  currency: PropTypes.string.isRequired,
  countryCode: PropTypes.string.isRequired,
  amounts: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  isMobile: PropTypes.bool.isRequired,
  basketId: PropTypes.string.isRequired,
  basket: PropTypes.shape().isRequired,
  isTouchCapable: PropTypes.bool.isRequired,
  isSmallScreen: PropTypes.bool.isRequired,
  page: PropTypes.shape().isRequired,
  salesChannelId: PropTypes.string.isRequired,
  salesChannelGroup: PropTypes.string.isRequired,
  useRedeemLabels: PropTypes.bool.isRequired,
  mode: PropTypes.string.isRequired,
  currencyFilter: PropTypes.string.isRequired,
  wrapping: PropTypes.shape({
    data: PropTypes.shape({
      items: PropTypes.arrayOf(
        PropTypes.shape({
          labels: PropTypes.shape().isRequired,
          id: PropTypes.string.isRequired,
          wrappingPriceNoTax: PropTypes.number.isRequired,
          wrappingPriceCurrency: PropTypes.string.isRequired,
        }),
      ).isRequired,
    }).isRequired,
  }).isRequired,
  productNotInStock: PropTypes.bool.isRequired,
  stockInfo: PropTypes.arrayOf(
    PropTypes.shape({
      deliveryMethod: PropTypes.string.isRequired,
      skuStockInfo: PropTypes.arrayOf(
        PropTypes.shape({
          inStock: PropTypes.bool.isRequired,
          sku: PropTypes.string.isRequired,
        }).isRequired,
      ).isRequired,
      allSkusOutOfStock: PropTypes.bool.isRequired,
    }),
  ),
};

Product.defaultProps = {
  stockInfo: null,
};

const mapState = state => {
  const {
    data: { deliveryMethods },
    formData,
    stockInfo,
  } = state.product;

  return {
    product: {
      ...state.product,
      productNotInStock: stockInfo?.every?.(
        ({ allSkusOutOfStock = true }) => !!allSkusOutOfStock,
      ),
    },
    basketId: state.basket.id,
    basket: state.basket,
    addDisabled: state.basket.loading,
    amounts: deliveryMethods[formData.deliveryMethod],
    currency: state.intl.currency,
    locale: state.intl.locale,
    mode: state.user.mode,
    countryCode: state.intl.countryCode,
    page: state.page.byName.product,
    salesChannelId: state.config.salesChannelId,
    salesChannelGroup: state.config.salesChannel.group,
    currencyFilter: state.product.currencyFilter || '',
    useRedeemLabels:
      state.basket.totalVoucherAmount >=
      state.basket.totalPurchaseAmountWithTax +
        state.product.formData.productPurchasePrice,
    wrapping: state.wrapping,
  };
};

export default compose(
  injectIntl,
  connect(mapState),
  withResponsiveWrapper(),
  withStyles(lightboxStyles, s),
)(Product);
